<template>
  <footer v-show="isVisible">
    <div class="container">
      <div class="row">
        <div class="row-inc">
          <div class="top">
            <Logo/>
            <div class="licence-footer">
              <div class="licence-button">
                <a target="_blank" href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbG95U0hNck9WSmtlbXdyVmtSNk4wbzJhbWxZTTNjOVBTSXNJblpoYkhWbElqb2ljV2cxVERCWVVrTkhNRzFpWWpCWmIyWTJlRXN6WnowOUlpd2liV0ZqSWpvaU4ySm1NbUUzWVRGbU1EVXhOMlEwT0RnME5tUTBaR0prWlRBME1EQTVaREV5TXpZNVlqTXpOalUzWTJJd01ERmxNemxqWmpFeE56Vm1PR1kxWmpBM01pSXNJblJoWnlJNklpSjk=">
                  <img src="https://seal.cgcb.info/8b089e55-4795-425a-6bf6-fdb75eba6900" width="88" height="50">
                </a>
              </div>
              <SocialMedia/>
            </div>
          </div>
          <div class="center">
            <div class="row">
              <div class="col items" v-if="!isMobile">
                <h1>Spor</h1>
                <ul>
                  <li><router-link :to="{ name: 'Sportsbook'}"> Spor Bahisleri</router-link></li>
                  <li><router-link :to="{ name: 'Live'}"> Canlı Bahis</router-link></li>
                  <li><router-link :to="{ name: 'Virtual'}"> Sanal Bahis</router-link></li>
                </ul>
              </div>
              <div class="col items" v-if="!isMobile">
                <h1>Casino</h1>
                <ul>
                  <li><router-link :to="{ name: 'Slot'}"> Casino</router-link></li>
                  <li><router-link :to="{ name: 'Casino'}"> Canlı Casino</router-link></li>
                </ul>
              </div>
              <div class="col items" v-if="!isMobile">
                <h1>Sanal</h1>
                <ul>
                  <li><router-link :to="{ name: 'Sportsbook'}"> Mobil Oyunlar</router-link></li>
                  <li><router-link :to="{ name: 'Live'}"> E-Sporlar</router-link></li>
                </ul>
              </div>
              <div class="col items" v-if="!isMobile">
                <h1>Masa Oyunları</h1>
                <ul>
                  <li><router-link :to="{ name: 'Betongames'}"> Poker</router-link></li>
                  <li><router-link :to="{ name: 'Bingo'}"> Tombala</router-link></li>
                  <li><router-link :to="{ name: 'Bingo'}"> TV Games</router-link></li>
                </ul>
              </div>
              <div class="col items">
                <h1>Yardım</h1>
                <ul>
                  <li v-for="(item, key) in pages" :key="key"><router-link :to="{ name: 'Page', params:{slug: item.url} }">{{ item.title }}</router-link></li>
                </ul>
              </div>
              <div class="col items">
                <h1>İletişim</h1>
                <ul>
                  <li><a href="javascript:;">destek@{{ _.lowerCase($store.getters['getClientMeta'].name).split(' ').join('') }}.com</a></li>
                  <li><a href="javascript:;">marketing@{{ _.lowerCase($store.getters['getClientMeta'].name).split(' ').join('') }}.com</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div style="text-align: center;" class="footer-lc">
            {{ $store.getters['getClientMeta'].name }}  website is operated by Joker Marketing B.V and currently in the GCB application process
          </div><br>
          <img src="@/assets/images/common/footer-providers.png" v-if="!isMobile" class="footer-c-providers">
          <img src="@/assets/images/common/footer-providers-m.png" v-if="isMobile" class="footer-c-providers">
          <div class="providers">
            <swiper v-if="providers.length>0" :options="providerSwiper">
              <swiper-slide v-for="item,key in providers" :key="key">
               <img :key="item" :src="$store.state.main.cdn_url + '/providers/' +  _.toLower(item)  + '.png'" width="80">
              </swiper-slide>
            </swiper>
          </div>
          <div class="licence">
            <!-- <img src="@/assets/images/common/licence.png" width="40"> -->
            <div class="age">
              +18 
            </div>
            <span>
              Avrupa’da kurulan ve kısa sürede bahis dünyasında kendine yer bulan {{ $store.getters['getClientMeta'].name }} bahis sitesi, kaliteli hizmetlerini etkin bir ekiple sizlerle paylaşmaya devam ediyor. Tüm dünyanın güvendiği {{ $store.getters['getClientMeta'].name }} kullanışlı ve etkili tasarımı ile size benzersiz hizmetler sunduğunu ve hem eğlenip hem de para kazandığınızı belirtmek isteriz.
            </span>
          </div>
          <p class="copyright">© 2022 {{ $store.getters['getClientMeta'].name }} Tüm hakları saklıdır.</p>
        </div>
      </div>
    </div>
  </footer>
</template>
<style lang="scss">
  .licence-footer{
    display: flex;
  }
  #app.mobile .licence-footer{
    flex-direction: column;
    align-content: center;
    justify-content: center;
    .licence-button{
      text-align: center;
    }
  }
</style>
<script>
	import Logo from './Header/Logo'
	import SocialMedia from './SocialMedia'
  export default{
    data(){
      return{
        providerSwiper: {
					speed: 500,
          slidesPerView: 8,
          loop: true,
          autoplay: {
            delay: 2000,
					},
        },
      }
    },
    computed:{
      providers(){
        return this.$store.getters['special/footerProviders'];
      },
      social(){
        return this.$store.getters.getClientContent;
      },
      pages() {
        return this.$store.getters.getClientPages;
      },
      lang(){
        return this.$store.getters.getLanguages;
      },
      isVisible(){
        if(this.$route.name == 'Homepage' && this.isMobile || !this.isMobile){
          return true;
        }else{
          return false;
        }
      }
    },
    methods:{
      upTop(){
        window.scrollTo(0,0);
      }
    },
		components:{
      Logo,
			SocialMedia
		}
  }
</script>